module.exports = __webpack_public_path__ + "static/media/green-p.f2c8baac.svg";